import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import LoginScreen from "./screens/Login";
import { PrivacyPolicy, TermsConditions, RefundPolicy } from "./screens/LegalPages";

import MainTabs from "./Customer/Screens/mainScreen";
import Home from "./Customer/Screens/TabsPage/HomePage";
import Categories from "./Customer/Screens/TabsPage/CategoriesPage";
import Orders from "./Customer/Screens/TabsPage/OrdersPage";
import Profile from "./Customer/Screens/TabsPage/ProfilePage";

// Admin
import Dashboard from "./screens/Dashboard";
import AddProduct from "./screens/AddProduct";
import SubCategory from "./screens/SubCategory";
import SupportOrder from "./screens/SupportOrder";
import OldOrderScreen from "./screens/OldOrderScreen";
import SupportDashboard from "./screens/SupportDashboard";
import PartnerRegistration from "./screens/PartnerRegistration";


function App() {
  return (
    <Router>
      <Routes>

        {/* Landing Page */}
        <Route path="/" element={<LoginScreen />} />

        {/* Legal Pages */}
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-conditions" element={<TermsConditions />} />
        <Route path="/refund-policy" element={<RefundPolicy />} />
        {/* 
        Customer App UI
        <Route path="/app" element={<MainTabs />}>
          <Route path="home" element={<Home />} />
          <Route path="categories" element={<Categories />} />
          <Route path="orders" element={<Orders />} />
          <Route path="profile" element={<Profile />} />
        </Route> */}

        {/* Admin Panel */}
        <Route path="/admin" element={<Dashboard />} />
        <Route path="/admin/partner/register" element={<PartnerRegistration />} />
        <Route path="/editProduct/:productId" element={<AddProduct />} />
        <Route path="/category/:catname" element={<SubCategory />} />
        <Route path="/neworder" element={<SupportOrder />} />
        <Route path="/OldOrderScreen" element={<OldOrderScreen />} />
        <Route path="/AdminDashboard" element={<SupportDashboard />} />

      </Routes>
    </Router>
  );
}

export default App;
